import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useWallets } from "@/api/wallets"
import WalletUnlock from "@/wallet/wallet-unlock"
import SendFlow from "./send.flow"
import { useState } from "react"

interface SendModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function SendModal({ open, onOpenChange }: SendModalProps) {
  const { wallet } = useWallets()
  const [isWithdrawing, setIsWithdrawing] = useState(false)

  if (!wallet) {
    return null
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(open) => !isWithdrawing && onOpenChange(open)}
    >
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Send</DialogTitle>
          {!isWithdrawing && <DialogClose />}
        </DialogHeader>
        <WalletUnlock>
          <SendFlow
            onDone={() => onOpenChange(false)}
            onStart={() => setIsWithdrawing(true)}
          />
        </WalletUnlock>
      </DialogContent>
    </Dialog>
  )
}
